import WebFont from 'webfontloader';
import getStore from 'services/getStore';
import fonts from './fonts';
import parseFontUrl from './parseFontUrl';
import getActiveBlocks from 'services/apiHelpers/getActiveBlocks';
import { loadAssets } from 'components/lib/BootScreen';

const store = getStore();
const { fontFamily = '', fontFamilies = [] } = store.getState().theme;

// we can refactor this to something faster later
let fontFamilyMarks = [];

Object.values(store.getState().blocks).forEach((b: any) => {
  // Object.values(getActiveBlocks() as any).forEach((b: any) => {
  if (!(b.type === 'Text' && b.props.content)) return;
  //
  const fontFamily = b.props.content
    .split(/\<|\>/g)
    .filter((entry: any) => entry.includes('style="font-family:'))
    // .filter((entry: any) => !!entry)
    .map((entry: any) =>
      entry
        .replace(/\"|span|style|\=|font-family:|data-type|fontFamily/g, '')
        .trimStart()
        .trimEnd()
    )
    .filter((entry: any) => entry !== '');

  fontFamilyMarks = [...fontFamilyMarks, ...fontFamily];
});

fontFamilyMarks = Array.from(new Set([fontFamily, ...fontFamilyMarks]) as any);

// console.log(fontFamilyMarks);

// TODO
// turn this into a promise and move it out into own file. . .
const addFont = (url, targetWindow = window) => {
  if (!url) return;

  const { fontName, fontExtension, fontFormat } = parseFontUrl(url); //  = chunks[chunks.length - 1].split(/\./);

  // if it's default ( empty ) or is on the google fonts list ( fonts ). bail
  if (!fontName || fonts.includes(fontName)) return fontName;

  const head = targetWindow.document.querySelector('head');
  if (head.querySelector(`#${fontName}`)) return;

  const styleTag = document.createElement('style');

  styleTag.id = fontName;
  styleTag.innerHTML = `
    @font-face {
      font-family: "${fontName}";
      src: url("${url}") format("${fontFormat}");
    }
  `;

  head.appendChild(styleTag);

  return fontName;

  // implement this ?
  // const loadFont = new FontFace(font, `url(fonts/${font}.ttf)`);
  // loadFont
  //   .load()
  //   .then(function(loaded_face) {
  //     (document as any).fonts.add(loaded_face);
  //     document.body.style.fontFamily = `"${font}", Arial`;
  //   })
  //   .catch(function(error) {
  //     // error occurred
  //   });
};

// here's the flag
// window.loadUserSelectedFonts = true;

const WebFontConfig = {
  google: {
    families:
      // window.mode === 'DEVELOPMENT'
      //   ? [...fonts.map(f => `${f}:400,700`)]
      //   : [`${fontFamily}:400,700`],
      // [
      //   ...(window.mode === 'DEVELOPMENT' ? fonts : fontFamilyMarks).map(
      //     f => `${f}:400,700`
      //   ),
      // ],
      [
        ...(window['loadUserSelectedFonts'] ? fontFamilyMarks : fonts).map(
          f => `${f}:400,700`
        ),
      ],
  },
  custom: {
    // families: fontFamilies,
  },
  loading: () => {},
  active: () => {
    loadAssets.loadFonts && loadAssets.loadFonts();
  },
  inactive: () => {
    console.log('NO UserSelectedFonts TO LOAD');
    loadAssets.loadFonts && loadAssets.loadFonts();
  },
  fontloading: (familyName, fvd) => {
    // console.log(familyName, fvd);
  },
  fontactive: (familyName, fvd) => {
    // console.log(familyName, fvd);
  },
  fontinactive: (familyName, fvd) => {
    // console.log(familyName, fvd);
  },
};

// boot these up. if any
if (!!fontFamilies.length) {
  fontFamilies.forEach(f => {
    addFont(f);
  });
}

WebFont.load(WebFontConfig);

export { addFont };
